if (!customElements.get('custom-key-features')) {
  customElements.define(
    'custom-key-features',
    class CustomKeyFeatures extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.mainProductInfo = document.querySelector('product-info');
        this.productFormActions = document.querySelector('.main-product-form');
        this.variantMetafields = document.getElementById('variant-metafields-product-overview');
        this.rawVariantMetafields = JSON.parse(this.variantMetafields.textContent);
        this.featuresContainer = this.querySelector('.variant-features-container');
        this.variantMetafieldValues = {};
        for (const [variantId, data] of Object.entries(this.rawVariantMetafields)) {
            this.variantMetafieldValues[variantId] = {
              ...data.pdp,
              key_features: data.key_features || null
            };
          }
        this.subscribeToVariantChange();
      }
      subscribeToVariantChange() {
      FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, (event) => {
      const variant = event.data.variant;
      const data = this.variantMetafieldValues[variant.id];
    if (data?.key_features) {
      this.updateFeatures(data.key_features);
    } else {
      this.updateFeatures(null);
    }
  });
}
updateFeatures(keyFeaturesTextArray) {
  const featuresWrapper = this.querySelector('.features-wrapper');
  if (!this.featuresContainer) return;
  const rawText = keyFeaturesTextArray?.[0] || "";
  const features = rawText.split('\n').map(f => f.replace(/^- /, '').trim()).filter(f => f !== '');
    if (features.length === 0) {
    featuresWrapper?.classList.add('hidden');
    return;
  }
  featuresWrapper?.classList.remove('hidden');
  const listHTML = `<ul class="variant-features">${features.map(f => `<li>${f}</li>`).join('')}</ul>`;
  this.featuresContainer.innerHTML = listHTML;
}
    }
  );
}
